<template>
	<hr class="dropdown-divider mx-4" />
</template>

<script>
export default {
	name: "WsDropdownItemDivider"
};
</script>
